<template>
    <div class="help-tooltip-wrapper">
        <i class="fa fa-circle-info text-secondary"></i>
        <div class="help-tooltip-popup">
            <span>{{ text }}</span>
            <span v-if="linkUrl" class="help-tooltip-link" @click="openLink">{{ linkLabel }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "HelpTooltip",
    props: {
        text: { type: String, required: true },
        linkLabel: { type: String, default: "Learn more" },
        linkUrl: { type: String, default: null },
    },
    methods: {
        openLink() {
            window.open(this.linkUrl, '_blank', 'noopener,noreferrer');
        }
    }
}
</script>

<style scoped>
.help-tooltip-wrapper {
    position: relative;
    display: inline-flex;
    align-items: center;
}

.help-tooltip-popup {
    display: none;
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.12);
    padding: 8px 12px;
    min-width: 220px;
    max-width: 320px;
    font-size: 0.8rem;
    color: #495057;
    white-space: normal;
    z-index: 1060;
    line-height: 1.4;
}

.help-tooltip-popup::before {
    content: '';
    position: absolute;
    top: -8px;
    left: 0;
    right: 0;
    height: 8px;
}

.help-tooltip-wrapper:hover .help-tooltip-popup {
    display: block;
}

.help-tooltip-link {
    display: block;
    margin-top: 6px;
    color: #0d6efd;
    text-decoration: underline;
    cursor: pointer;
}
</style>
